import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject, Input, ViewChild } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { HeaderComponent } from '@portal/header';
import { MegaMenuComponent, MegaMenuService } from '@portal/mega-menu';
import { LayoutConfig } from './layout.type';
import { HOME_PAGE_SME_URL } from '@portal/data-access';

@Component({
  selector: 'portal-layout',
  standalone: true,
  imports: [NgClass, MatSidenavModule, HeaderComponent, MegaMenuComponent, NgStyle],
  templateUrl: './layout.component.html',
  styles: [
    `
      :host {
        @apply block;
      }

      ::ng-deep .mat-drawer-container {
        color: inherit;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MegaMenuService],
})
export class LayoutComponent {
  private readonly megaMenuService = inject(MegaMenuService);
  @ViewChild('banner', { static: true }) private banner?: ElementRef<HTMLDivElement>;
  protected readonly heightHeader = 56;
  protected isOpenSidenav = false;
  protected isScroll = false;
  protected HOME_PAGE_SME_URL = HOME_PAGE_SME_URL;

  private _config!: LayoutConfig;

  get config(): LayoutConfig {
    return this._config;
  }

  @Input() set config(value: LayoutConfig) {
    this._config = value;
  }

  protected toggleSidenav(): void {
    this.isOpenSidenav = !this.isOpenSidenav;

    // reset mega menu state when toggle sidebar
    this.megaMenuService.resetState$.next(true);
  }

  @HostListener('window:scroll', [])
  private onWindowScroll(): void {
    const { top } = this.banner?.nativeElement?.getBoundingClientRect() ?? { top: this.heightHeader };
    this.isScroll = top < 0;
  }
}
